import { Component, Input, ContentChild, QueryList, ElementRef, TemplateRef} from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'app-card-toggle',
  standalone: true,
  imports: [NgTemplateOutlet],
  templateUrl: './card-toggle.component.html',
  styleUrl: './card-toggle.component.css'
})
export class CardToggleComponent {
  flag: boolean = false;

  @ContentChild('titleTemplate')
  titleTemplate?: TemplateRef<any> = undefined;

  @Input()
  cardTitle: string = 'title';

  @Input()
  titleClass: string = 'text-start';

  @Input()
  contentClass: string = '';

  @Input()
  containerClass: string = '';

  @Input()
  iconCard: string = '';
  
  @Input()
  hasTitle: boolean = true;

  ngOnInit() {
    console.log('ngOnInit!');
  }

  toggleContenido() {
    this.flag = !this.flag;
  }
}
